import Breadcrumb from './../components/BreadCrumb';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';
import PricingSection from './../sections/PricingSection';

function PricingScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Pricing Plans'>
          <Breadcrumb screen='Pricing Plans'/>
        </HeadingDetailsSection>
        <div className='mb-20'>
            <PricingSection/>
        </div>
    </>
  );
}

export default PricingScreen;
